'use client';

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { clientAxios } from '@/shared/api';
import { ApiResponse } from '@/shared/types';

export interface AgreementApiResponse {
  privacy_marketing_consent: boolean;
  date_privacy_marketing_consent: string | null;
  date_reject_privacy_marketing_consent: string | null;
  receive_marketing_info_consent: boolean;
  date_receive_marketing_info_consent: string | null;
  date_reject_receive_marketing_info_consent: string | null;
}

export const useGetAgreement = () => {
  return useQuery({
    queryKey: ['getAgreementApi'],
    queryFn: async () => {
      const { data } =
        await clientAxios.get<ApiResponse<AgreementApiResponse>>(
          '/getAgreementApi/'
        );

      return (
        data.data.privacy_marketing_consent &&
        data.data.receive_marketing_info_consent
      );
    },
  });
};

export const usePatchAgreement = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ isAgree }: { isAgree: boolean }) =>
      clientAxios.patch('/patchMarketingAgreementApi/', { isAgree }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['getAgreementApi'],
      });
      await queryClient.invalidateQueries({
        queryKey: ['notificationSettings'],
      });
    },
  });
};
